<template></template>

<script>
export default {
  props:{
    slidesCount: {
      default: 3
    },
    autoPlay: {
      default: false,
      type: Boolean
    },
    autoSlideDelay: {
      default: 7000
    },
    name: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data(){
    return{
      currentSliderIndex: 1,
      timerHolder: null,
      swiperOption: {
        effect: 'slide',
        speed: 500,
        freeMode: false,
        watchOverflow: false,
        threshold: 10,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
      }
    }
  },
  computed: {
    slider() {
      return this[this.name];
    },
    getOptions() {
      return { ...this.swiperOption, ...this.options };
    },
  },
  methods:{
    setActiveSlide(id){
      this.currentSliderIndex = id;
    },
    nextSlide(){
      if(this.currentSliderIndex === this.slidesCount){
        this.currentSliderIndex = 1;
      }else{
        this.currentSliderIndex++;
      }
    },
    prevSlide(){
      if(this.currentSliderIndex === 1){
        this.currentSliderIndex = this.slidesCount;
      }else{
        this.currentSliderIndex--;
      }
    },
    assignSetTimeout(){
      const self = this;
      return setTimeout(function tick() {
        self.nextSlide();
        self.timerHolder = setTimeout(tick, self.autoSlideDelay);
      },  self.autoSlideDelay);
    },
    stopAutoSlide(){
      if(this.autoPlay) clearTimeout(this.timerHolder);
    },
    initAutoSlide(){
      if(this.autoPlay) this.timerHolder = this.assignSetTimeout();
    },
    autoplayInit() {
      const needPlay = this.slidesCount > 1;
      const isAutoplayRun = this.slider && this.slider.autoplay && this.slider.autoplay.running;
      if (needPlay && !isAutoplayRun) {
        this.slider && this.slider.autoplay && this.slider.autoplay.start();
      } else if (!needPlay && isAutoplayRun) {
        this.stopAutoplay();
      }
    },
    stopAutoplay() {
      if (this.slider.autoplay.running) this.slider.autoplay.stop();
    },
  },
  mounted(){
    if (this.autoPlay) {
      this.autoplayInit();
    }
  }
}
</script>

<style scoped>

</style>
